import { clsx } from '../../utils/cn.js';

export default function PremiumCard({ children, className, hover, variant = 'dark', solid = false, fullHeight = false }) {
  const light = variant === 'light';
  const darkSolid = !light && solid;
  return (
    <div className={fullHeight ? 'h-full' : undefined}>
      <div
        className={clsx(
          'relative rounded-2xl p-6',
          fullHeight && 'flex h-full min-h-[10.5rem] flex-col',
          light && 'border border-slate-100 bg-white shadow-sm',
          !light &&
            !darkSolid &&
            'border border-white/5 bg-slate-950/75 bg-card-shine shadow-md shadow-black/45 backdrop-blur-md',
          darkSolid &&
            'border border-slate-800 bg-slate-950 bg-card-shine shadow-md shadow-slate-900/25',
          hover &&
            (light
              ? 'transition duration-200 ease-out hover:border-slate-200 hover:shadow-md'
              : darkSolid
                ? 'transition duration-300 ease-out hover:-translate-y-1 hover:border-white/16 hover:shadow-premium motion-reduce:transition-colors motion-reduce:hover:translate-y-0'
                : 'will-change-transform transition duration-300 ease-out hover:-translate-y-1 hover:border-white/16 hover:shadow-premium motion-reduce:transition-colors motion-reduce:hover:translate-y-0'),
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
